module.exports = __webpack_public_path__ + "static/media/tm-colorit-8-sm.97e68b22.webp";